import Bars from './Bars'

export default Bars
